import(/* webpackMode: "eager" */ "/app/app/l/[slug]/not-found.tsx");
